import axios from 'axios'

export default {
    validate(params) {
        return new Promise((resolve, reject) => {
            axios.post(`/auth/api/users/validate`, { ExpectedResponse: params.Response })
                .then(response => {
                    if (response.data.hasErrors) {
                        reject(response.data.message)
                    } else {
                        resolve(response.data)
                    }
                })
                .catch(error => {
                    if (error.response.data.hasOwnProperty('hasErrors')) {
                        reject(error.response.data.message)
                    } else {
                        reject(error.message)
                    }
                })
        })
    }
}


// WEBPACK FOOTER //
// ./Scripts/app/recaptchaValidate.js